import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRoomContext } from '@livekit/components-react';
import { ConnectionQuality, RoomEvent } from 'livekit-client';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { BtwHeading, BtwText, Stack } from '@marvelapp/ballpark-components';
import { showWarningNotification } from '@marvelapp/ui-internal';
export const ConnectionQualityMonitor = observer(function ConnectionQualityMonitor() {
    const room = useRoomContext();
    const [hasShownPoorQualityToast, setHasShownPoorQualityToast] = useState(false);
    const [connectionStartTime] = useState(Date.now());
    useEffect(() => {
        const handleQualityChange = (quality) => {
            const timeSinceConnection = Date.now() - connectionStartTime;
            if (quality === ConnectionQuality.Poor &&
                !hasShownPoorQualityToast &&
                timeSinceConnection > 30000) {
                showWarningNotification({
                    content: (_jsxs(Stack, { gap: "1", children: [_jsx(BtwHeading, { size: "sm", variant: "white", children: "Poor connection quality" }), _jsx(BtwText, { size: "xs", variant: "white", children: "Your connection quality is poor. This may affect the video quality." })] })),
                    toastId: 'poor-connection-quality',
                    options: { autoClose: 5000 },
                });
                setHasShownPoorQualityToast(true);
            }
        };
        room.on(RoomEvent.ConnectionQualityChanged, handleQualityChange);
        return () => {
            room.off(RoomEvent.ConnectionQualityChanged, handleQualityChange);
        };
    }, [room, hasShownPoorQualityToast, connectionStartTime]);
    return null;
});
